var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AllRecordsTable',{attrs:{"submit-button-text":_vm.table.submitButtonText,"table-name":_vm.contactType,"link-slug":_vm.contactType,"title":_vm.table.title,"columns":_vm.table.columnNames,"order-fields":_vm.orderFields,"filter-fields":_vm.table.filterFields,"rows":_vm.table.rowNames}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0b2588","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/business/pages/AllBusinessContactsPage.vue
// module id = null
// module chunks = 